import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import Tooltip from 'primevue/tooltip';

// PrimeVue theme + base CSS
import 'primevue/resources/themes/lara-light-indigo/theme.css';
import 'primeicons/primeicons.css';

import App from './App.vue';
import router from './router';
import './styles/main.css';
import { loadSiteMode } from './utils/site';

// Site-mode flag (single-region vs multi-region) is needed by the auth
// guard inside router.beforeEach BEFORE the first navigation resolves.
// Kick the fetch off here; it updates the cached flag synchronously
// available to isSingleRegion() / isMainSite().
//
// We don't .await it: the router module is already evaluated (route set
// was picked from the localStorage hint in site.js). Mount immediately
// so the SPA shell renders without blocking on a network round-trip;
// the beforeEach guard re-checks the flag once the fetch lands.
loadSiteMode();

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(PrimeVue, { ripple: true });
app.use(ToastService);
app.use(ConfirmationService);
// PrimeVue Tooltip is a directive, not a plugin — must be registered
// separately so `v-tooltip.top="..."` works on info icons across the
// app (e.g. mapping editor field help hints).
app.directive('tooltip', Tooltip);

app.mount('#app');
